export const ADD_PROMOTION='ADD_PROMOTION'
export const ADD_PROMOTION_SUCCESS= 'ADD_PROMOTION_SUCCESS'
export const ADD_PROMOTION_ERROR= 'ADD_PROMOTION_ERROR'

export const CHANGE_PROMOTIONS_VISIBILITY='CHANGE_PROMOTIONS_VISIBILITY'
export const CHANGE_PROMOTIONS_VISIBILITY_SUCCESS= 'CHANGE_PROMOTIONS_VISIBILITY_SUCCESS'
export const CHANGE_PROMOTIONS_VISIBILITY_ERROR= 'CHANGE_PROMOTIONS_VISIBILITY_ERROR'

export const DELETE_PROMOTION='DELETE_PROMOTION'
export const DELETE_PROMOTION_SUCCESS= 'DELETE_PROMOTION_SUCCESS'
export const DELETE_PROMOTION_ERROR= 'DELETE_PROMOTION_ERROR'

export const DELETE_PROMOTIONS='DELETE_PROMOTIONS'
export const DELETE_PROMOTIONS_SUCCESS= 'DELETE_PROMOTIONS_SUCCESS'
export const DELETE_PROMOTIONS_ERROR= 'DELETE_PROMOTIONS_ERROR'

export const GET_PROMOTION= 'GET_PROMOTION'
export const GET_PROMOTION_SUCCESS= 'GET_PROMOTION_SUCCESS'
export const GET_PROMOTION_ERROR= 'GET_PROMOTION_ERROR'

export const GET_PROMOTIONS= 'GET_PROMOTIONS'
export const GET_PROMOTIONS_SUCCESS= 'GET_PROMOTIONS_SUCCESS'
export const GET_PROMOTIONS_ERROR='GET_PROMOTIONS_ERROR'

export const UNDELETE_PROMOTION='UNDELETE_PROMOTION'
export const UNDELETE_PROMOTION_SUCCESS= 'UNDELETE_PROMOTION_SUCCESS'
export const UNDELETE_PROMOTION_ERROR='DELETE_PROMOTION_ERROR'

export const UNDELETE_PROMOTIONS='UNDELETE_PROMOTIONS'
export const UNDELETE_PROMOTIONS_SUCCESS= 'UNDELETE_PROMOTIONS_SUCCESS'
export const UNDELETE_PROMOTIONS_ERROR= 'DELETE_PROMOTIONS_ERROR'

export const UPDATE_PROMOTION='UPDATE_PROMOTION'
export const UPDATE_PROMOTION_SUCCESS= 'UPDATE_PROMOTION_SUCCESS'
export const UPDATE_PROMOTION_ERROR='UPDATE_PROMOTION_ERROR'


export const AddPromotion= (data) => ({
    type: ADD_PROMOTION,
    payload: data
})

export const ChangePromotionsVisibility= (data) => ({
    type: CHANGE_PROMOTIONS_VISIBILITY,
    payload: data
})

export const DeletePromotion= (data) => ({
    type: DELETE_PROMOTION,
    payload: data
})

export const DeletePromotions= (data) => ({
    type: DELETE_PROMOTIONS,
    payload: data
})

export const GetPromotion= (data) => ({
    type: GET_PROMOTION,
    payload: data
})

export const GetPromotions= (data) => ({
    type: GET_PROMOTIONS,
    payload: data
})


export const UnDeletePromotion= (data) => ({
    type: UNDELETE_PROMOTION,
    payload: data
})

export const UnDeletePromotions= (data) => ({
    type: UNDELETE_PROMOTIONS,
    payload: data
})

export const UpdatePromotion= (data) => ({
    type: UPDATE_PROMOTION,
    payload: data
})
